import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CompanyResponseDto } from "../../shared/dtos/company/CompanyResponseDto";

export interface CompanyState {
  loadingCompany: boolean;
  loadingCompanyUpdate: boolean;
  loadingCompanySetup: boolean;
  errorLoadingCompany: string | null;
  errorUpdatingCompany: string | null;
  errorSetupCompany: string | null;
  company: CompanyResponseDto | null;
  serverStatus: number | null;
}

const getStoredCompany = (): CompanyResponseDto | null => {
  try {
    const storedCompany = localStorage.getItem("companyInfo");

    if (!storedCompany) {
      return null;
    }

    return JSON.parse(storedCompany) as CompanyResponseDto;
  } catch {
    localStorage.removeItem("companyInfo");
    return null;
  }
};

const initialState: CompanyState = {
  loadingCompany: false,
  loadingCompanyUpdate: false,
  loadingCompanySetup: false,
  errorLoadingCompany: null,
  errorUpdatingCompany: null,
  errorSetupCompany: null,
  company: getStoredCompany(),
  serverStatus: null,
};

export const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    setLoadingCompany(state) {
      state.loadingCompany = true;
      state.errorLoadingCompany = null;
    },
    setLoadingCompanyUpdate(state) {
      state.loadingCompanyUpdate = true;
      state.errorUpdatingCompany = null;
    },
    setLoadingCompanySetup(state) {
      state.loadingCompanySetup = true;
      state.errorSetupCompany = null;
    },
    setErrorLoadingCompany(state, action: PayloadAction<string | null>) {
      state.loadingCompany = false;
      state.errorLoadingCompany = action.payload;
    },
    setErrorUpdatingCompany(state, action: PayloadAction<string | null>) {
      state.loadingCompanyUpdate = false;
      state.errorUpdatingCompany = action.payload;
    },
    setErrorSetupCompany(state, action: PayloadAction<string | null>) {
      state.loadingCompanySetup = false;
      state.errorSetupCompany = action.payload;
    },
    setCompany(state, action: PayloadAction<CompanyResponseDto>) {
      state.loadingCompany = false;
      state.loadingCompanySetup = false;
      state.company = action.payload;
    },
    updateCompanySuccess(state, action: PayloadAction<CompanyResponseDto>) {
      state.loadingCompanyUpdate = false;
      state.company = action.payload;
    },
    clearCompany(state) {
      state.company = null;
      localStorage.removeItem("companyInfo");
    },
    setServerResponseStatus(state, action: PayloadAction<number | null>) {
      state.serverStatus = action.payload;
    },
  },
});

export const companyActions = companySlice.actions;
export default companySlice.reducer;
